
import Vue from "vue";
import TabList from "@/components/TabList.vue";
export default Vue.extend({
  components: { TabList },
  data: () => ({
    tab: {
      selectedTab: 0,
      tabTitle: "研究方向",
      tabs: [
        { text: "整体介绍", path: "/group" },
        { text: "语音前端", path: "/group/fe" },
        { text: "语音识别", path: "/group/asr" },
        { text: "语音合成", path: "/group/tts" },
        { text: "声纹识别", path: "/group/sv" },
      ],
    },
  }),
  created() {
    const nameMap: any = { groupIndex: 0, feIndex: 1, asrIndex: 2, ttsIndex: 3, svIndex: 4 };
    this.tab.selectedTab = nameMap[this.$route.name as string] ?? 0;
  },
});
